export const distLocal = [
  {
    id: 1,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/1.jpg",
    title: "Distrito Local 01",
  },
  {
    id: 2,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/2.jpg",
    title: "Distrito Local 02",
  },
  {
    id: 3,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/3.jpg",
    title: "Distrito Local 03",
  },
  {
    id: 4,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/4.jpg",
    title: "Distrito Local 04",
  },
  {
    id: 5,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/5.jpg",
    title: "Distrito Local 05",
  },
  {
    id: 6,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/6.jpg",
    title: "Distrito Local 06",
  },
  {
    id: 7,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/7.jpg",
    title: "Distrito Local 07",
  },
  {
    id: 8,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/8.jpg",
    title: "Distrito Local 08",
  },
  {
    id: 9,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/9.jpg",
    title: "Distrito Local 09",
  },
  {
    id: 10,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/10.jpg",
    title: "Distrito Local 10",
  },
  {
    id: 11,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/11.jpg",
    title: "Distrito Local 11",
  },
  {
    id: 12,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/12.jpg",
    title: "Distrito Local 12",
  },
  {
    id: 13,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/13.jpg",
    title: "Distrito Local 13",
  },
  {
    id: 14,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/14.jpg",
    title: "Distrito Local 14",
  },
  {
    id: 15,
    link: "https://itetlax.org.mx/assets/img/imgDemA/distLocal/15.jpg",
    title: "Distrito Local 15",
  },
];

export const intDist = [
  {
    id: 1,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/1.jpg",
    title: "Distrito Local 01",
  },
  {
    id: 2,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/2.jpg",
    title: "Distrito Local 02",
  },
  {
    id: 3,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/3.jpg",
    title: "Distrito Local 03",
  },
  {
    id: 4,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/4.jpg",
    title: "Distrito Local 04",
  },
  {
    id: 5,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/5.jpg",
    title: "Distrito Local 05",
  },
  {
    id: 6,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/6.jpg",
    title: "Distrito Local 06",
  },
  {
    id: 7,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/7.jpg",
    title: "Distrito Local 07",
  },
  {
    id: 8,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/8.jpg",
    title: "Distrito Local 08",
  },
  {
    id: 9,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/9.jpg",
    title: "Distrito Local 09",
  },
  {
    id: 10,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/10.jpg",
    title: "Distrito Local 10",
  },
  {
    id: 11,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/11.jpg",
    title: "Distrito Local 11",
  },
  {
    id: 12,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/12.jpg",
    title: "Distrito Local 12",
  },
  {
    id: 13,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/13.jpg",
    title: "Distrito Local 13",
  },
  {
    id: 14,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/14.jpg",
    title: "Distrito Local 14",
  },
  {
    id: 15,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/15.jpg",
    title: "Distrito Local 15",
  },
];
export const infoRel = [
  {
    id: 16,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/16.jpg",
    title: "¿Sabías qué...?",
  },
  // {
  //   id: 17,
  //   link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/17.jpg",
  //   title: "Distritación Local Electoral",
  // },
  {
    id: 18,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/18.jpg",
    title: "Ubica tu Distrito",
  },
  {
    id: 19,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/19.jpg",
    title: "Distritación Local Electoral 2022",
  },
  {
    id: 20,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/20.jpg",
    title: "Nueva Distritación Local Tlaxcala 2022",
  },
  {
    id: 21,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/21.jpg",
    title: "¿Para? ¿Por qué? ¿Cuáles? ¿Cuándo?",
  },
  {
    id: 22,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/22.jpg",
    title: "¿Qué es una Sección Electoral?",
  },
  {
    id: 23,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/23.jpg",
    title: "15 Distritos Locales",
  },
  {
    id: 24,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/24.jpg",
    title: "¡Identifica tu Distrito!",
  },
  {
    id: 25,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/25.jpg",
    title: "Cabeceras Distritales",
  },
  {
    id: 26,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/26.jpg",
    title: "¿Sabías qué el municipio de Apizaco...?",
  },
  {
    id: 27,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/27.jpg",
    title: "¿Sabías qué el municipio de Sanctórum...?",
  },
  {
    id: 28,
    link: "https://itetlax.org.mx/assets/img/imgDemA/infografias/28.jpg",
    title: "¿Sabías qué el municipio de Huamantla...?",
  },
];
